export const SvgArrowDownIcon = (props) => {
  return (
    <svg
      width={7}
      height={5}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      style={{ marginBottom: '2px' }}
    >
      <path
        d="M6.625.731a.625.625 0 0 0-.881 0L3.5 2.944 1.288.73a.625.625 0 1 0-.882.888l2.65 2.65a.625.625 0 0 0 .888 0l2.681-2.65a.625.625 0 0 0 0-.888Z"
        fill="#1F1F1F"
      />
    </svg>
  )
}

export const SvgArrowRightIcon = (props) => {
  return (
    <svg
      width={6}
      height={10}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.358 4.408 1.825.875A.833.833 0 1 0 .642 2.05L3.592 5 .642 7.95a.833.833 0 0 0 .271 1.355c.102.041.21.062.32.062a.833.833 0 0 0 .592-.242l3.533-3.533a.833.833 0 0 0 0-1.184Z"
        fill="#0A446E"
      />
    </svg>
  )
}

export const SvgMapsPin = (props) => (
  <svg
    width={14}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 .667A6.667 6.667 0 0 0 .333 7.333c0 4.5 5.875 9.584 6.125 9.8a.833.833 0 0 0 1.083 0c.292-.216 6.125-5.3 6.125-9.8A6.666 6.666 0 0 0 7 .667Zm0 14.708c-1.775-1.667-5-5.258-5-8.042a5 5 0 0 1 10 0c0 2.784-3.225 6.383-5 8.042ZM7 4a3.333 3.333 0 1 0 0 6.667A3.333 3.333 0 0 0 7 4Zm0 5a1.667 1.667 0 1 1 0-3.333A1.667 1.667 0 0 1 7 9Z"
      fill="#fff"
    />
  </svg>
)

export const SvgEnvelope = (props) => (
  <svg
    width={18}
    height={14}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.833.333H3.167a2.5 2.5 0 0 0-2.5 2.5v8.334a2.5 2.5 0 0 0 2.5 2.5h11.666a2.5 2.5 0 0 0 2.5-2.5V2.833a2.5 2.5 0 0 0-2.5-2.5ZM14.492 2l-4.9 4.9a.833.833 0 0 1-1.184 0L3.508 2h10.983Zm1.174 9.167a.833.833 0 0 1-.833.833H3.167a.833.833 0 0 1-.834-.833V3.175l4.9 4.9a2.5 2.5 0 0 0 3.534 0l4.9-4.9v7.992Z"
      fill="#fff"
    />
  </svg>
)

export const SvgPhone = (props) => (
  <svg
    width={18}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.2 9.833c-.183 0-.375-.058-.558-.1a7.87 7.87 0 0 1-1.092-.325 1.666 1.666 0 0 0-2.067.834l-.183.375A10.15 10.15 0 0 1 9.083 8.95a10.15 10.15 0 0 1-1.666-2.217l.35-.233A1.667 1.667 0 0 0 8.6 4.433a8.608 8.608 0 0 1-.325-1.091 6.182 6.182 0 0 1-.1-.567A2.5 2.5 0 0 0 5.675.7h-2.5a2.5 2.5 0 0 0-2.5 2.842 15.833 15.833 0 0 0 13.767 13.716h.316a2.5 2.5 0 0 0 2.285-1.481 2.5 2.5 0 0 0 .215-1.027v-2.5A2.5 2.5 0 0 0 15.2 9.833Zm.417 5a.833.833 0 0 1-.603.802.875.875 0 0 1-.364.032A14.166 14.166 0 0 1 2.392 3.35a.908.908 0 0 1 .208-.683.833.833 0 0 1 .625-.284h2.5a.833.833 0 0 1 .833.659c.034.227.075.452.125.675.096.439.225.87.384 1.291L5.9 5.55a.834.834 0 0 0-.408 1.108 12.075 12.075 0 0 0 5.833 5.834c.203.083.43.083.633 0a.831.831 0 0 0 .475-.434l.517-1.166c.43.154.87.282 1.317.383.222.05.447.092.675.125a.833.833 0 0 1 .658.833l.017 2.6Z"
      fill="#fff"
    />
  </svg>
)
